import _ from 'lodash';
import React from 'react';
import { createRoot } from 'react-dom/client';
import airbrake from 'common/airbrake';
import { I18n } from 'common/i18n';

import { isDevelopmentEnvironment } from 'common/environment';
import store from './store';
import App from './App';

airbrake.init(window.serverConfig.airbrakeProjectId, window.serverConfig.airbrakeKey);

// Defer rendering so the spinner in the ERB can render.
_.defer(function () {
  // Render the App, falling back to rendering an error if it fails.
  try {
    const container = document.querySelector('#app');
    createRoot(container).render(<App store={store} />);
  } catch (e) {
    // TODO: Catching-all makes stack traces hard to parse in a development context. The links
    // in the console don't take you to the code that threw. Instead, they take you to the
    // raw webpack-generated eval() calls.
    console.error('Fatal error when rendering:', e);

    const container = document.querySelector('.placeholder-wrapper');
    createRoot(container).render(
      <div>
        <div className="alert error alert-full-width-top">
          {I18n.t('shared.measures_editor.render_error')}
        </div>
        {isDevelopmentEnvironment() && <pre>{e.stack}</pre>}
      </div>,
    );

    throw e;
  }

  // Show the footer once the App has attempted to render.
  const footer = document.querySelector('#site-chrome-footer');
  if (footer) {
    footer.style.visibility = 'visible';
  }
});
